import { render, staticRenderFns } from "./CriacaoDocumentoModal.vue?vue&type=template&id=7dfd64a4&scoped=true&lang=pug"
import script from "./CriacaoDocumentoModal.vue?vue&type=script&lang=js"
export * from "./CriacaoDocumentoModal.vue?vue&type=script&lang=js"
import style0 from "./CriacaoDocumentoModal.vue?vue&type=style&index=0&id=7dfd64a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfd64a4",
  null
  
)

export default component.exports